import { render, staticRenderFns } from "./OverridesListing.vue?vue&type=template&id=388bb11a&"
import script from "./OverridesListing.vue?vue&type=script&lang=js&"
export * from "./OverridesListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports